/* eslint-disable prettier/prettier */
/* eslint-disable prefer-template */

/**
 * Returns a svg path as a rounded rectangle.
 * @param  {Number} w   Width of rounded rectangle
 * @param  {Number} h   Height of rounded rectangle
 * @param  {Number} r   Corner radius
 */
export const roundedRectData = (w, h, r) => {
  return (
    'M 0 ' +
    r +
    ' A ' +
    r +
    ' ' +
    r +
    ' 0 0 1 ' +
    r +
    ' 0' +
    ' L ' +
    (w - r) +
    ' 0' +
    ' A ' +
    r +
    ' ' +
    r +
    ' 0 0 1 ' +
    w +
    ' ' +
    r +
    ' L ' +
    w +
    ' ' +
    (h - r) +
    ' A ' +
    r +
    ' ' +
    r +
    ' 0 0 1 ' +
    (w - r) +
    ' ' +
    h +
    ' L ' +
    r +
    ' ' +
    h +
    ' A ' +
    r +
    ' ' +
    r +
    ' 0 0 1 0 ' +
    (h - r) +
    ' Z'
  );
};
/**
 * Downloads a blob file for the user
 * @param {Blob} blob file to download
 */
export const downloadFile = (blob, filename) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
